import axios, { AxiosResponse } from "axios";
import AxiosService from "./Axios";

class DashboardApi {
    
    public async getSystemOverview(): Promise<AxiosResponse<any>> {
        return AxiosService.get('/dashboard/system-overview');
    }

}

export default DashboardApi;